export function isSameDate(a, b) {
    const isSameYear = a.getUTCFullYear() === b.getUTCFullYear();
    const isSameMonth = a.getMonth() === b.getMonth();
    const isSameDay = a.getDay() === b.getDay();
    return isSameDay && isSameMonth && isSameYear;
}

export const DATE_FORMAT = { month: 'short', day: 'numeric' };
export const LOCALE = 'en-US';
